//console.log('Hiss');

import '../sass/styles.scss';
import $ from "jquery";
import 'uikit/dist/js/uikit.min';
// import 'uikit/dist/js/uikit-icons';
// import 'uikit/dist/js/uikit-icons.min.js';
import UIkit from 'uikit/dist/js/uikit.min';
import Icons from 'uikit/dist/js/uikit-icons.min.js';

// loads the Icon plugin
UIkit.use(Icons);

$(document).ready(function(){
    console.log(12);
});



// $(function() {
//     var header = $("body");
//
//     $(window).scroll(function() {
//         var scroll = $(window).scrollTop();
//         if (scroll >= 100) {
//             header.addClass("is-page-scrolled");
//         } else {
//             header.removeClass("is-page-scrolled");
//         }
//     });
//
// });
